wbApp.controller('AttendanceLogDetailCtrl', ['$scope', 'rfidCardsSvc', 'securitySvc',
function ($scope, rfidCardsSvc, securitySvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.inUpdateRole = securitySvc.isInRole('RfidCardLog.Update');
    $scope.inInsertRole = securitySvc.isInRole('RfidCardLog.Insert');
    $scope.isDisabled = $scope.model.isDeleted ||
        (!!$scope.modelOrig.rfidCardLogID && !$scope.inUpdateRole) ||
        (!$scope.modelOrig.rfidCardLogID && !$scope.inInsertRole);

    $scope.isSaving = false;

    $scope.onUserTypeChange = function (model) {
        model.userID = null;
    }

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (!model.rfidCardLogID) {
            rfidCardsSvc.insert(model, $scope.collection, success, error);
        } else {
            rfidCardsSvc.update(model, $scope.collection, success, error);
        }

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
            $scope.onSave();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }
}]);
